module.exports = __webpack_public_path__ + "img/detalhe-atuamos.cf79a9cc.svg";